<template>
  <section class="specs">
    <div class="specs__content container">
      <div class="specs__list">
        <ul class="specs__list-left">
          <li class="--fade-in-up" data-vertical-ivp-class="--animate"><b>Huge potential market</b><br> 125 million existing homes in the U.S. </li>
          <li class="--fade-in-up --delay-1" data-vertical-ivp-class="--animate">System removes 12,000-14,000 pounds of carbon per year per household Carbon
              free living for new and existing homes</li>
          <li class="--fade-in-up --delay-2" data-vertical-ivp-class="--animate">Combining solar, geothermal, indoor air purification, and advanced smart home technology</li>
        </ul>
        <ul class="specs__list-right">
         <li class="--fade-in-up --delay-1" data-vertical-ivp-class="--animate">The Inflation Reduction Act of 2022 (IRA) includes $369 billion for “Energy Security
              and Climate Change,” paving the way for the growth of turnkey electric home solutions.</li>
          <li class="--fade-in-up --delay-1" data-vertical-ivp-class="--animate">Ground floor for climate conscious and socially responsible investors</li>
          <li id="last-item" class="--fade-in-up --delay-2" data-vertical-ivp-class="--animate">Open to all investors with as little as $300 required</li>
        </ul>
      </div>
      <CTA ctaText="LEARN MORE"/>
    </div>
  </section>
</template>

<script>
import CTA from '../components/cta.vue';

export default {
  name: 'specs',
  components: {
    CTA
  },
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/components/specs.scss";
</style>
